// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___wAk1O","btn":"style__btn___1G8ce"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/ui/components/auth-social/style.css
// module id = 845
// module chunks = 0